<div class="modal-content">
  <div class="modal-body text-center">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <jhi-bary-icon *ngIf="icon" [icon]="icon" [faDirective]="FAS" size="4x" [class]="class + ' text-align'"></jhi-bary-icon>
    <p class="lead pt-4" [innerHTML]="message"></p>
  </div>
  <div class="modal-footer justify-content-center">
    <jhi-bary-button (clickEvent)="handleClick({ second: true })" *ngIf="buttons.second" [label]="buttons.second" [outline]="true" class="mr-2"></jhi-bary-button>
    <jhi-bary-button *ngIf="buttons.submit" [block]="!buttons.second" color="primary" [label]="buttons.submit" (clickEvent)="handleClick({ submit: true })"></jhi-bary-button>
  </div>
</div>
